module.exports = __webpack_public_path__ + "assets/72b27c3c5393575ac6775e3448c750ac.mp3";